import { createFileRoute } from "@tanstack/react-router";
import {
  Navbar,
  Hero,
  WhatDrivesUs,
  LifeAtHilltop,
  Admissions,
  Footer,
} from "@/components/hilltop";

export const Route = createFileRoute("/_public/")({
  component: HomePage,
});

function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <WhatDrivesUs />
      <LifeAtHilltop />
      <Admissions />
      <Footer />
    </div>
  );
}
